import { registerRoutes, ReverbRouteObject } from '@reverbdotcom/commons/src/route_settings';
import DiscoveryRoutes from '../discovery-routes';
import buildRootRoutes from './build_root_routes';

/**
 * The reverb.com root route tree, built once and shared by every entrypoint
 * that needs it: the browser router (reverb-ui/src/components/discovery.js)
 * and the SSR bundle (reverb-ui/src/server.ts). Importing this module is how
 * consumers get the routes -- there is no global to read them back from.
 */
export const Routes = buildRootRoutes(DiscoveryRoutes);

// buildRootRoutes returns react-router's RouteObject[]; ReverbRouteObject only
// narrows `handle`/`index` for authored route elements, so the cast is safe.
registerRoutes(Routes as ReverbRouteObject[]);

export default Routes;
